import pharmacy from 'services/pharmacy';
import { useDispatch } from 'react-redux';
import { SET_ERROR_MESSAGE } from 'helpers/types';
import { browserHistory } from 'App';

export default () => {
  const dispatch = useDispatch();
  const postOrder = async (
    paymentJourney,
    medicationState,
    basketMedication,
    gpNotes,
    totalValue,
  ) => {
    const order = {
      order_items: basketMedication.map((medication) => ({
        name: medication.name,
        course_id: medication.course_id,
        dosage: medication.dosage,
        item_id: medication.item_id,
        item_price: medication.price,
      })),
      total_amount: {
        main_digits: Object.keys(paymentJourney.payment).length === 0 ? 0 : parseInt(totalValue.split('.')[0]),
        fraction_digits: Object.keys(paymentJourney.payment).length === 0 ? 0 : parseInt(totalValue.split('.')[1]),
        currency_code: 'GBP',
      },
      gp_notes: gpNotes,
      fulfillment: {
        delivery_type: paymentJourney.delivery_type,
        pharmacy_ods_code: paymentJourney.delivery_type === 'homeDelivery' ? 'FGF90' : paymentJourney.address.ods_code,
        pharmacy_name: paymentJourney.delivery_type === 'homeDelivery' ? 'Co-op' : paymentJourney.address.name,
        address: {
          address_line1: checkNullString(paymentJourney.address.address_line1),
          address_line2: checkNullString(paymentJourney.address.address_line2),
          address_line3: checkNullString(paymentJourney.address.address_line3),
          address_line4: checkNullString(
            paymentJourney.delivery_type === 'homeDelivery' || paymentJourney.delivery_type === 'pharmacyDelivery'
              ? ''
              : paymentJourney.address.address_line4
          ),
          address_line5: '',
          postcode: paymentJourney.address.postcode,
        },
      },
      ...(Object.keys(paymentJourney.exemption).length !== 0 && {
        exemption: {
          code: paymentJourney.exemption.type.option,
          name: paymentJourney.exemption.type.text,
          ...(paymentJourney.exemption.cert_number && { number: paymentJourney.exemption.cert_number }),
          ...(paymentJourney.exemption.cert_expiry && { expiry_date: paymentJourney.exemption.cert_expiry }),
          ...(paymentJourney.exemption.ni_number && { ni_number: paymentJourney.exemption.ni_number }),
        },
      }),
      ...(Object.keys(paymentJourney.payment).length !== 0 && { card_token: paymentJourney.payment.token }),
      prescription_comment_allowed: medicationState.gp_settings.prescription_comment_allowed,
      prescription_comment_mandatory: medicationState.gp_settings.prescription_comment_mandatory,
    };
    try {
      return await pharmacy.post(`/patients/orders`, order, { headers: { 'api-version': 'v2' } });
    } catch (e) {
      if (e.response && e.response.data.readable_error_message) {
        dispatch({
          type: SET_ERROR_MESSAGE,
          payload: {
            msg: e.response.data.readable_error_message,
            newMessage: true,
            link: '',
            ctaText: '',
          },
        });
        browserHistory.push('/pharmacy/error');
      }
      throw e;
    }
  };

  const postConfirmation = async (ckoSessionId) => {
    try {
      const response = await pharmacy.post(`/patients/orders/confirmation`, null, {
        headers: { 'api-version': 'v2' },
        params: { 'cko-session-id': ckoSessionId },
      });
      return response.data;
    } catch (e) {
      if (e.response && e.response.data.readable_error_message) {
        dispatch({
          type: SET_ERROR_MESSAGE,
          payload: {
            msg: e.response.data.readable_error_message,
            newMessage: true,
            link: '',
            ctaText: '',
          },
        });
        browserHistory.push('/pharmacy/error');
      } else {
        browserHistory.push('/pharmacy/error');
      }
      throw e;
    }
  };

  const checkNullString = (checkString) => {
    return checkString ? checkString : '';
  };

  return [postOrder, postConfirmation];
};
